import React, { Fragment, useCallback, useContext } from 'react'
import { ClientDetailedDto } from 'api/Clients/Types/ClientDetailedDto'
import { UpdateClientStatus } from 'api/Clients/Types/UpdateClientStatus'
import { Spinner } from 'components/Spinner'
import { TransactionsStatisticOverviewModalView } from 'routes/Transactions/Details/TransactionsStatisticOverview/TransactionsStatisticOverview'
import { useApiClient } from 'utils/api/ApiClient'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'
import { useFetchOne } from 'utils/api/useFetch'
import { AuthSessionContext } from 'utils/AuthContext'

import { normalizeStatistics } from '../../../../Transactions/Details/TransactionsStatisticOverview/normalizer'
import { ClientNavigation, ClientTab } from '../../Navigation/ClientNavigation'

interface Props {
  data: ClientDetailedDto

  forceRefresh(): void
  updateClientStatus(values: UpdateClientStatus): void
}

const ClientDetailsStatisticsPage: React.FC<Props> = ({ data, updateClientStatus }) => {
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)
  const [auth] = useContext(AuthSessionContext)
  const permissions = auth?.permissions || []

  const statisticsFetchData = useCallback(
    () => tradingAccountsApiClient.getTradingAccountPlatformStatistics(data.id),
    [data.id] // eslint-disable-line react-hooks/exhaustive-deps
  )
  const { data: stats, isLoading: loading } = useFetchOne(statisticsFetchData)

  if (loading) {
    return <Spinner />
  }
  if (!data) {
    return null
  }

  return (
    <Fragment>
      <ClientNavigation
        isEdit={false}
        data={data}
        tab={ClientTab.STATISTICS}
        updateClientStatus={updateClientStatus}
      />
      <TransactionsStatisticOverviewModalView
        statistics={normalizeStatistics(stats || [])}
        permissions={permissions}
      />
    </Fragment>
  )
}

export default ClientDetailsStatisticsPage
